// extracted by mini-css-extract-plugin
module.exports = {"Heading__wrapper":"Heading_Heading__wrapper__TX4Je"};